import { Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';

@Pipe({
  name: 'dateTimeFormat'
})

export class DateTimeFormatPipe extends DatePipe implements PipeTransform {
  transform(value: any, args?: any): any {
    const dateValue = value ? new Date(value.replace(/\s/g, 'T')) : value;
    return super.transform(dateValue, args);
  }

}
